// Recovered compiled webpack factory 89135. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { LZ: () => p, ao: () => _, k1: () => m });
  var n = r(26552),
    a = r(2257),
    o = r(88722),
    i = r(30249),
    s = r(22758),
    l = r(90929),
    u = r(73314),
    c = r(51290),
    f = r(20753);
  let d = "_frozenDsc";
  function p(e, t) {
    (0, u.my)(e, d, t);
  }
  function h(e, t) {
    let r = t.getOptions(),
      { publicKey: a } = t.getDsn() || {},
      o = {
        environment: r.environment || n.U,
        release: r.release,
        public_key: a,
        trace_id: e,
        org_id: (0, s.ul)(t),
      };
    return (t.emit("createDsc", o), o);
  }
  function _(e, t) {
    let r = t.getPropagationContext();
    return r.dsc || h(r.traceId, e);
  }
  function m(e) {
    let t = (0, a.KU)();
    if (!t) return {};
    let r = (0, c.zU)(e),
      n = (0, c.et)(r),
      s = n.data,
      u = r.spanContext().traceState,
      p = u?.get("sentry.sample_rate") ?? s[o.sy] ?? s[o.Ef];
    function _(e) {
      return (("number" == typeof p || "string" == typeof p) && (e.sample_rate = `${p}`), e);
    }
    let m = r[d];
    if (m) return _(m);
    let g = u?.get("sentry.dsc"),
      y = g && (0, i.yD)(g);
    if (y) return _(y);
    let v = h(e.spanContext().traceId, t),
      b = s[o.i_],
      E = n.description;
    return (
      "url" !== b && E && (v.transaction = E),
      (0, l.f)() &&
        ((v.sampled = String((0, c.pK)(r))),
        (v.sample_rand =
          u?.get("sentry.sample_rand") ??
          (0, f.L)(r).scope?.getPropagationContext().sampleRand.toString())),
      _(v),
      t.emit("createDsc", v, r),
      v
    );
  }
}
